module.exports = __webpack_public_path__ + "img/valet.78bbb61a.svg";